import React, { useEffect, useState } from "react";
import { Box, CssBaseline } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { getCarrierByBusinessName } from "../../redux/action/carrier";
import { unwrapResult } from "@reduxjs/toolkit";
import AdminSidebar from "../adminSidebar/AdminSidebar";
import AdminDashboardHeader from "../adminDashboardHeader/AdminDashboardHeader";
import AdminContentArea from "../adminContentArea/AdminContentArea";

const AdminLayout: React.FC = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);
  const [activeComponent, setActiveComponent] = useState("AdminCarriers");
  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };
  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />
      <AdminDashboardHeader
        sidebarOpen={sidebarOpen}
        toggleSidebar={toggleSidebar}
      />
      <AdminSidebar
        sidebarOpen={sidebarOpen}
        setActiveComponent={setActiveComponent}
        toggleSidebar={toggleSidebar}
      />
      <AdminContentArea
        sidebarOpen={sidebarOpen}
        activeComponent={activeComponent}
      />
    </Box>
  );
};

export default AdminLayout;
